import { useMemo } from 'react';

import { useUserDetails } from 'api/useUserDetails';
import { Project, UserRole } from 'common/contracts';
import {
  EPermissionAction,
  EPermissionGroup,
  IPermissions
} from 'common/permissions.types';
import { ELocalStorageKeys } from 'constants/enums';
import { localStorageUtil } from 'utils/localStorageUtil';

export function useUserPermissions() {
  const { userDetails } = useUserDetails();

  return useMemo(
    () => ({
      isActionEnabled: (
        permissions: IPermissions | null,
        group: EPermissionGroup,
        action: EPermissionAction,
        activeProject?: string
      ) => {
        const pathParam = window.location.pathname.split('/')[2];
        const projectsDetails = userDetails?.projects;
        const isProjectItem = projectsDetails?.some(
          (project: Project) => project.publisherId === pathParam
        );

        permissions =
          permissions ||
          localStorageUtil.get<IPermissions>(ELocalStorageKeys.PERMISSIONS);

        activeProject =
          activeProject ||
          localStorageUtil.get<string>(ELocalStorageKeys.PUBLISHER_ID) ||
          (isProjectItem ? pathParam : undefined);

        if (!permissions || !activeProject) return false;
        return permissions?.[activeProject]?.[group]?.includes(action);
      },

      generateTooltipEditPermissionString: () => {
        const userRole = userDetails?.role;
        return userRole === UserRole.SUPPORT
          ? "You don't have access to perform this action"
          : '';
      },

      getRoleByPublisherId: (publisherId: string) => {
        if (!publisherId || !userDetails) return null;
        return (
          userDetails.projects?.find(
            (p: Project) => p?.publisherId === publisherId
          )?.role || null
        );
      }
    }),
    [userDetails]
  );
}

